import { NavTutorial } from '@components/tutorial/NavTutorial';
import { PlanetInfo } from '@components/helpers/PlanetInfo';
import { Glitch } from '@components/helpers/Glitch';
import { Locked } from '@components/helpers/Locked';
import { useTranslation } from 'react-i18next';
import { useSetPlanetMutation } from '@http';
import { useAppStore } from '@stores';
import * as Shared from '@shared/lib';
import { useState } from 'react';

export function Navigation() {
  const [showMissions, setShowMissions] = useState<string | null>(null);

  const { t } = useTranslation(undefined, { keyPrefix: 'Planets' });
  const { mutateAsync } = useSetPlanetMutation();
  const { userData, setTab } = useAppStore();

  const isLocked = (location: Shared.PlanetData) => {
    return userData.missionLevel < location.levelRange.from;
  };

  const openLobby = async (planet: string, mission?: number) => {
    await mutateAsync({ planet, mission });
    setTab('lobby');
  };

  const clickOn = (location: Shared.PlanetData) => {
    if (isLocked(location)) return;

    if (location.missions?.length) {
      return setShowMissions(n => {
        return n === location.name ? null : location.name;
      });
    }

    openLobby(location.name);
  };

  return (
    <div className="overflow-y-auto h-full">
      <NavTutorial />
      {Shared.planetData.map((location, index) => (
        <div key={index}>
          <PlanetInfo
            onClick={() => clickOn(location)}
            locked={isLocked(location)}
            name={location.name}
          />

          <div className={`${showMissions === location.name && 'visible'} mission-list`}>
            <div className="p-2 pb-0">
              {location.missions?.map((mission, index) => (
                <button
                  onClick={() => openLobby(location.name, index)}
                  key={`${location.name}-${index}`}
                  className="mission-list-btn"
                >
                  <div className="bg-1 grid-overlay" />
                  <div className="bg-2" />

                  <p className="type">
                    <Glitch disabled={userData.missionLevel < mission.levelRange.from}>
                      {mission.faction || location.faction || 'Aegis'}
                      {' '}
                      {t(`Missions.${mission.type}`)}
                    </Glitch>
                  </p>

                  <p className="level">
                    {t('level')} {mission.levelRange.from} - {mission.levelRange.to}
                  </p>

                  <Locked show={userData.missionLevel < mission.levelRange.from} />
                </button>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}